import { ActiveModel, ActiveField } from '@alt-point/active-models/src'
import { WebUserProfileUpdate } from './WebUserProfileUpdate'
/**
* Class WebUserUpdate
*  Данные для изменения аккаунта пользователя
*/
export class WebUserUpdate extends ActiveModel {

  /**
  * profile
  * Данные для обновления профиля пользователя  */
  @ActiveField({
    factory: [WebUserProfileUpdate, () => undefined]
  })
  profile?: WebUserProfileUpdate
}
